// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__DRlcJ","container":"styles_container__1lRrj","title":"styles_title__2DhSw","wrapper":"styles_wrapper__VPPL7","answer":"styles_answer__3532X"};